module.exports = __webpack_public_path__ + "static/media/icon-snappy-process.3cc5dc39.svg";